// extracted by mini-css-extract-plugin
export default {"noDataContainer":"noData_noDataContainer__6G5Di"};